export default "__VITE_ASSET__CB1Gu5h6__"